// languagetools:disable
import Link from 'next/link'
import React from 'react'

import { WORKSPACE_ROUTES } from '../../../constants/routes'

interface IPostHeader {
  postData: {
    loadNumber?: string
    postID: string
    workspacename?: string
  }
}

/**
 * Displays the header of a Offer chat component.
 */
export const Header = ({ postData }: IPostHeader) => {
  const { postID, loadNumber, workspacename } = postData

  return (
    <div className="flex h-[72px] items-center border-b px-4">
      <div className="flex min-w-0 items-center gap-2">
        <span className="text-xl">🚚</span>
        <span className="font-semibold">Load number</span>
        <span className="text-muted-foreground">›</span>
        {workspacename ? (
          <Link
            href={`${WORKSPACE_ROUTES.POSTS(workspacename)}/${postID}`}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold hover:underline truncate text-md transition-colors"
          >
            {loadNumber}
          </Link>
        ) : (
          <span className="font-bold truncate text-md">{loadNumber}</span>
        )}
      </div>
    </div>
  )
}
